import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('tabSampleStore', Object.keys(getters)),
	...mapState('tabSampleStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('tabSampleStore', Object.keys(actions)),
	...mapMutations('tabSampleStore', Object.keys(mutations))
};
